import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Compose class names, letting later Tailwind utilities win over earlier ones.
 *
 * Plain concatenation doesn't do that — `"p-2" + " p-4"` leaves both in the class
 * list and which applies comes down to their order in the stylesheet, not the call
 * site. `twMerge` resolves the conflict the way the caller means it, which matters
 * for components that take a `className` override.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
